import { render, staticRenderFns } from "./Businesses.vue?vue&type=template&id=2dd60ef0&"
import script from "./Businesses.vue?vue&type=script&lang=js&"
export * from "./Businesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports